import { render, staticRenderFns } from "./AppThemeFrame.vue?vue&type=template&id=6a59ce3e"
import script from "./AppThemeFrame.vue?vue&type=script&lang=js"
export * from "./AppThemeFrame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports